import { formatDateObjToDateString } from '../../../utils/format_time';
var DEFAULT_DATE_FORMAT = 'M/D/YY';
/**
 * This is a helper file used to retrieve and format voucher date related information.
 */
export var getVoucherActiveAtDate = function (voucher, format) {
    if (format === void 0) { format = DEFAULT_DATE_FORMAT; }
    return formatDateObjToDateString(voucher.activeAtDate, format);
};
export var getVoucherInActiveAtDate = function (voucher, format) {
    if (format === void 0) { format = DEFAULT_DATE_FORMAT; }
    return formatDateObjToDateString(voucher.inactiveAtDate, format);
};
export var getVoucherValidPeriod = function (voucher) {
    var activeAtDate = voucher.activeAtDate;
    if (!activeAtDate)
        return '';
    var formattedStartDate = getVoucherActiveAtDate(voucher);
    var formattedEndDate = getVoucherInActiveAtDate(voucher);
    // voucher is single day use
    if (formattedStartDate === formattedEndDate) {
        return formattedStartDate;
    }
    if (!formattedEndDate) {
        return formattedStartDate;
    }
    return formattedStartDate + ' - ' + formattedEndDate;
};
